import React from "react";
import { createPortal } from "react-dom";
import ToastContainer from "./ToastContainer";

const ToastPortal = ({ toasts, removeToast }) => {
  return createPortal(
    <ToastContainer toasts={toasts} removeToast={removeToast} />,
    document.getElementById("toasts")
  );
};

export default ToastPortal;
